import React, { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { EjercicioByRange } from "../../../Finanzas/Helper/EjercicioByRange";

const MESES = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];

// Filtro de Indicadores de Visitas — réplica de FiltroObjetivosMensuales (mismo patrón modal
// botón + PlantillaScreen + show/hide por id), con Ejercicio y Mes, más un filtro propio de este
// reporte: "Tipo" (Programadas/Realizadas), que el backend espera como "linea" ("P"/"R") en
// GET /ReporteVisitas. Se duplica en vez de compartir el componente para que cada pantalla
// mantenga su propio id de modal e independencia si alguna cambia a futuro.
export const FiltroIndicadoresVisitas = ({ onCargar, ejercicio, mes, tipo }) => {
  const [openModal, setOpenModal] = useState(false);
  const [filtro, setFiltro] = useState({ ejercicio, mes, tipo });

  const onOpenModal = () => {
    const container = document.getElementById("indVisFiltrosVisitas-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const onChangeMes = ({ target }) => setFiltro((prev) => ({ ...prev, mes: Number(target.value) }));
  const onChangeTipo = ({ target }) => setFiltro((prev) => ({ ...prev, tipo: target.value }));

  const handleCargar = () => {
    if (!filtro.ejercicio) {
      Swal.fire("INDICADORES DE VISITAS", "Selecciona el ejercicio para continuar", "warning");
      return;
    }
    onOpenModal();
    onCargar(filtro.ejercicio, filtro.mes, filtro.tipo);
  };

  return (
    <div className="rca-filtro">
      <button type="button" className="rca-filtro-btn" onClick={onOpenModal} aria-label="Filtrar">
        <FilterAltIcon /> <span className="crm-btn-label">Filtrar</span>
      </button>

      <div className="rca-filtro-modal" id="indVisFiltrosVisitas-modal">
        <PlantillaScreen titulo="Filtro" className_main={1} className="rca-filtro-modal-plantilla sinadr ind-vis-filtro-3campos">
          <div className="rca-filtro-modal-close" onClick={onOpenModal}>
            X
          </div>

          <div className="rca-filtro-modal-body">
            <div className="rca-filtro-modal-filtros">
              <div className="rca-filtro-tiempo">
                <div className="rca-filtro-group-B">
                  <label>Ejercicio</label>
                  <EjercicioByRange
                    name="ejercicio"
                    value={filtro.ejercicio}
                    onChange={(e) => setFiltro((prev) => ({ ...prev, ejercicio: Number(e.target.value) }))}
                  />
                </div>

                <div className="rca-filtro-group">
                  <label>Mes</label>
                  <select name="mes" value={filtro.mes} onChange={onChangeMes} className="rca-filtro-select">
                    {MESES.map((m) => (
                      <option key={m.value} value={m.value}>{m.label}</option>
                    ))}
                  </select>
                </div>

                <div className="rca-filtro-group">
                  <label>Tipo</label>
                  <select name="tipo" value={filtro.tipo} onChange={onChangeTipo} className="rca-filtro-select">
                    <option value="P">Programadas</option>
                    <option value="R">Realizadas</option>
                  </select>
                </div>

                <div className="rca-filtro-btn-cargar" onClick={handleCargar}>
                  Cargar
                </div>
              </div>
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};
